import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "confirm-overlay"
}
const _hoisted_2 = { class: "confirm-card" }
const _hoisted_3 = { class: "confirm-title" }
const _hoisted_4 = { class: "confirm-actions" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.open)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, "Deseja excluir \"" + _toDisplayString(_ctx.label) + "\"?", 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "link link-inline confirm-link",
              type: "button",
              disabled: _ctx.saving,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
            }, _toDisplayString(_ctx.saving ? 'Excluindo...' : 'Excluir'), 9, _hoisted_5),
            _createElementVNode("button", {
              class: "link link-inline confirm-link",
              type: "button",
              disabled: _ctx.saving,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
            }, "Cancelar", 8, _hoisted_6)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}